import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export const allFiltersSelector = createSelector(selector, (store) => store.appliedFilters);

export const selectedMetricsSelector = createSelector(selector, (store) => store.selectedMetrics);

export const sortedMetricsSelector = createSelector(selectedMetricsSelector, (metrics) =>
  Array.isArray(metrics) ? [...metrics].sort() : metrics,
);

export const selectedDimensionSelector = createSelector(
  selector,
  (store) => store.selectedDimension,
);

export const appliedSortSelector = createSelector(selector, (store) => store.appliedSort);

export const unitModeSelector = createSelector(selector, (store) => store.unit);

export const liveModeSelector = createSelector(selector, (store) => store.liveMode);

export const appliedSearchSelector = createSelector(selector, (store) => store.appliedSearch);

export default selector;
